import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" };
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "modal-header" };
const _hoisted_4 = { class: "modal-title" };
const _hoisted_5 = { class: "modal-body" };
const _hoisted_6 = {
    key: 0,
    class: "text-muted encuesta-desc"
};
const _hoisted_7 = {
    key: 1,
    class: "small text-secondary mb-3"
};
const _hoisted_8 = { class: "mb-3" };
const _hoisted_9 = {
    key: 2,
    class: "text-center text-muted py-3"
};
const _hoisted_10 = {
    key: 3,
    class: "alert alert-info py-2 small mb-3",
    role: "status"
};
const _hoisted_11 = {
    key: 4,
    class: "alert alert-warning py-2 small mb-3"
};
const _hoisted_12 = ["for"];
const _hoisted_13 = {
    key: 0,
    class: "text-danger"
};
const _hoisted_14 = {
    key: 0,
    class: "small text-muted mb-1"
};
const _hoisted_15 = {
    key: 1,
    class: "small text-secondary mb-2 fst-italic"
};
const _hoisted_16 = ["id", "onUpdate:modelValue", "maxlength", "minlength", "disabled"];
const _hoisted_17 = {
    key: 2,
    class: "form-text text-end"
};
const _hoisted_18 = {
    key: 6,
    class: "alert alert-danger py-2 small mb-0"
};
const _hoisted_19 = { class: "modal-footer" };
const _hoisted_20 = ["disabled"];
const _hoisted_21 = ["disabled"];
const _hoisted_22 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-1",
    role: "status"
};
const _hoisted_23 = {
    key: 1,
    class: "modal-backdrop fade show"
};
import { computed, reactive, ref, watch } from "vue";
import { SURVEY_QUESTION_TEXT_SHORT } from "@/types/survey";
import { fetchMySurveyResponse, submitSurveyResponse, updateMySurveyResponse, } from "@/services/surveyService";
import EncuestaResultadosModal from "./EncuestaResultadosModal.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EncuestaModal',
    props: {
        show: { type: Boolean },
        survey: {},
        schoolId: {},
        year: {},
        courseCode: {},
        encuestaIndex: {},
        totalEncuestas: {}
    },
    emits: ["close", "success"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const valores = reactive({});
        const guardando = ref(false);
        const errorGuardar = ref("");
        const cargandoRespuesta = ref(false);
        const tieneRespuestaExistente = ref(false);
        const errorCargaMiRespuesta = ref("");
        const showResultados = ref(false);
        const textoBotonGuardar = computed(() => tieneRespuestaExistente.value ? "Guardar cambios" : "Guardar");
        const shortQuestions = computed(() => {
            if (!props.survey?.questions)
                return [];
            return props.survey.questions.filter((q) => q.type === SURVEY_QUESTION_TEXT_SHORT);
        });
        const inicializarClavesVacias = () => {
            Object.keys(valores).forEach((k) => delete valores[k]);
            for (const q of shortQuestions.value) {
                valores[q.questionId] = "";
            }
        };
        const cargarMiRespuesta = async () => {
            if (!props.survey)
                return;
            errorCargaMiRespuesta.value = "";
            tieneRespuestaExistente.value = false;
            cargandoRespuesta.value = true;
            inicializarClavesVacias();
            try {
                const existing = await fetchMySurveyResponse(props.survey.surveyId);
                if (existing?.answers?.length) {
                    tieneRespuestaExistente.value = true;
                    for (const a of existing.answers) {
                        if (a.type === SURVEY_QUESTION_TEXT_SHORT &&
                            Object.prototype.hasOwnProperty.call(valores, a.questionId)) {
                            valores[a.questionId] = a.value ?? "";
                        }
                    }
                }
            }
            catch {
                errorCargaMiRespuesta.value =
                    "No se pudo cargar tu respuesta guardada. Puedes escribir desde cero.";
            }
            finally {
                cargandoRespuesta.value = false;
            }
        };
        watch(() => [props.show, props.survey?.surveyId], async ([abierto]) => {
            if (!abierto || !props.survey)
                return;
            errorGuardar.value = "";
            await cargarMiRespuesta();
        }, { immediate: true });
        const emitClose = () => {
            showResultados.value = false;
            emit("close");
        };
        const guardar = async () => {
            if (!props.survey)
                return;
            errorGuardar.value = "";
            for (const q of shortQuestions.value) {
                const v = (valores[q.questionId] || "").trim();
                if (q.required && !v) {
                    errorGuardar.value = "Completa las preguntas obligatorias.";
                    return;
                }
                if (q.minLength != null && v.length > 0 && v.length < q.minLength) {
                    errorGuardar.value = `La respuesta es demasiado corta (mín. ${q.minLength}).`;
                    return;
                }
            }
            guardando.value = true;
            try {
                const payload = {
                    surveyId: props.survey.surveyId,
                    school_id: props.schoolId,
                    year: props.year,
                    course_code: props.courseCode,
                    answers: shortQuestions.value.map((q) => ({
                        questionId: q.questionId,
                        value: (valores[q.questionId] || "").trim(),
                    })),
                };
                if (tieneRespuestaExistente.value) {
                    await updateMySurveyResponse(payload);
                }
                else {
                    await submitSurveyResponse(payload);
                    tieneRespuestaExistente.value = true;
                }
                emit("success");
            }
            catch (e) {
                const msg = axiosLikeMessage(e) ||
                    "No se pudo guardar la encuesta. Intenta nuevamente.";
                errorGuardar.value = msg;
            }
            finally {
                guardando.value = false;
            }
        };
        const axiosLikeMessage = (e) => {
            if (typeof e === "object" && e !== null && "response" in e) {
                const res = e
                    .response;
                const m = res?.data?.message;
                if (typeof m === "string" && m)
                    return m;
            }
            return "";
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.show && _ctx.survey)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal fade show encuesta-survey-modal",
                        style: { "display": "block" },
                        tabindex: "-1",
                        onClick: _withModifiers(emitClose, ["self"])
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("h5", _hoisted_4, [
                                        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-clipboard2-check me-2" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.survey.title), 1)
                                    ]),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "aria-label": "Cerrar",
                                        onClick: emitClose
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    (_ctx.survey.description)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.survey.description), 1))
                                        : _createCommentVNode("", true),
                                    (_ctx.totalEncuestas > 1)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Encuesta " + _toDisplayString(_ctx.encuestaIndex + 1) + " de " + _toDisplayString(_ctx.totalEncuestas), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_8, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-link btn-sm p-0 text-decoration-none",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (showResultados.value = true))
                                        }, _cache[3] || (_cache[3] = [
                                            _createElementVNode("i", { class: "bi bi-bar-chart-line me-1" }, null, -1),
                                            _createTextVNode(" Ver resultados agregados de la encuesta ")
                                        ]))
                                    ]),
                                    (cargandoRespuesta.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[4] || (_cache[4] = [
                                            _createElementVNode("span", {
                                                class: "spinner-border spinner-border-sm me-2",
                                                role: "status"
                                            }, null, -1),
                                            _createTextVNode(" Cargando tu respuesta… ")
                                        ])))
                                        : (tieneRespuestaExistente.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[5] || (_cache[5] = [
                                                _createElementVNode("i", { class: "bi bi-check-circle me-1" }, null, -1),
                                                _createTextVNode(" Ya respondiste esta encuesta. Puedes editar el texto y guardar de nuevo. ")
                                            ])))
                                            : _createCommentVNode("", true),
                                    (errorCargaMiRespuesta.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(errorCargaMiRespuesta.value), 1))
                                        : _createCommentVNode("", true),
                                    (!cargandoRespuesta.value)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(shortQuestions.value, (q) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: q.questionId,
                                                class: "mb-4 encuesta-pregunta"
                                            }, [
                                                _createElementVNode("label", {
                                                    class: "form-label fw-semibold",
                                                    for: `q-${q.questionId}`
                                                }, [
                                                    _createTextVNode(_toDisplayString(q.title) + " ", 1),
                                                    (q.required)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "*"))
                                                        : _createCommentVNode("", true)
                                                ], 8, _hoisted_12),
                                                (q.description)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(q.description), 1))
                                                    : _createCommentVNode("", true),
                                                (q.helpText)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(q.helpText), 1))
                                                    : _createCommentVNode("", true),
                                                _withDirectives(_createElementVNode("input", {
                                                    id: `q-${q.questionId}`,
                                                    type: "text",
                                                    class: "form-control",
                                                    "onUpdate:modelValue": ($event) => ((valores[q.questionId]) = $event),
                                                    maxlength: q.maxLength ?? undefined,
                                                    minlength: q.minLength ?? undefined,
                                                    disabled: cargandoRespuesta.value,
                                                    autocomplete: "off"
                                                }, null, 8, _hoisted_16), [
                                                    [_vModelText, valores[q.questionId]]
                                                ]),
                                                (q.maxLength)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString((valores[q.questionId] || "").length) + " / " + _toDisplayString(q.maxLength), 1))
                                                    : _createCommentVNode("", true)
                                            ]));
                                        }), 128))
                                        : _createCommentVNode("", true),
                                    (errorGuardar.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(errorGuardar.value), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-outline-secondary",
                                        disabled: guardando.value,
                                        onClick: emitClose
                                    }, " Cerrar ", 8, _hoisted_20),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-primary",
                                        disabled: guardando.value || cargandoRespuesta.value || shortQuestions.value.length === 0,
                                        onClick: guardar
                                    }, [
                                        (guardando.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(textoBotonGuardar.value), 1)
                                    ], 8, _hoisted_21)
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.show && _ctx.survey)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23))
                    : _createCommentVNode("", true),
                (_ctx.survey)
                    ? (_openBlock(), _createBlock(EncuestaResultadosModal, {
                        key: 2,
                        show: showResultados.value,
                        survey: _ctx.survey,
                        onClose: _cache[1] || (_cache[1] = ($event) => (showResultados.value = false))
                    }, null, 8, ["show", "survey"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
